<template>
	<div>
		<el-container style="position: absolute;top:0;bottom: 0;left: 0;right: 0;overflow: hidden;">
			<el-header class="d-flex align-items-center" style="background-color: #545c64;box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);">
				
				<div class="mr-auto d-flex align-items-center">
					<div ref="logowidth"  style="width: 180px;">
						<a  class="h5 mb-0 text-light"> {{$conf.logo}}</a>
					</div>
					<div ref="memuicon" class="ml-4"  style="color: #fff;font-size: 22px;cursor: pointer;">
						 <i @click="handleEdit()" 
						 :class="[isCollapse?'el-icon-s-fold':'el-icon-s-unfold']"></i>
					</div>
				</div>
				
				
				
				
				<el-menu :default-active="navBar.active" mode="horizontal" @select="handleSelect" background-color="#545c64" style="height: 60px;border: unset;"
				 text-color="#fff" active-text-color="#c09172" menu-trigger	="click">
				 
					<!-- <el-menu-item :class="is_phone?'el-menu-item2':''" :index="index|numToString" v-for="(item,index) in navBar.list" :key="index">
						{{item.name}}
						<el-badge v-if="item.is_num && num_list[item.is_num]>0" is-dot class="item"></el-badge>
					
					</el-menu-item> -->
					<el-menu-item index="200" class="p-0">
						<el-popover
						  placement="bottom"
						  width="350"
						  trigger="click">
						  <div class="lay_msg_view" >
							  <div class="py-3 lay_msg_title">
								  系统消息
							  </div>
							
							  <div @click="showNoticeModel(notice_item)" class="py-2 px-2 lay_msg_li"  v-for="notice_item in num_list.notice_arr" :key="notice_item.id">
								  
								  <div class="lay_msg_li_title">
									  <el-tag size="mini" v-if="notice_item.type==1">系统通知</el-tag>
									  <el-tag type="success" size="mini" v-if="notice_item.type==2">公告</el-tag>
								  {{notice_item.title}}</div>
								  <div  class="px-3 my-2 lay_msg_li_info" >
									 
										{{notice_item.content}}
									
								  </div>
								  
								   <div class="lay_msg_li_time" >{{notice_item.create_time}}</div>
							  </div>
							  

						
							  <div style="text-align: center;" class="pt-3">
								 
								 <router-link style="color: #666;" :to="{name:'data_notice'}">
								 	查看更多
								 </router-link>
							  </div>
						  </div>
						  <el-button class="lay_msg_btn px-3" slot="reference">
							  <i class="el-icon-message"></i>
							  <el-badge v-if="num_list['notice_num']>0"  is-dot class="item">
							   
							  </el-badge>
						  </el-button>
						</el-popover>
						
					</el-menu-item>
					
					<el-submenu index="100">
						<template slot="title">
							<el-avatar size="small" :src="user.head?user.head:user_mo"></el-avatar>
							<span v-show="!is_phone" class="ml-1">{{user.name}}</span>
						</template>
						<el-menu-item index="100-1"><i class="el-icon-user"></i>修改信息</el-menu-item>
						<el-menu-item index="100-3"><i class="el-icon-key"></i>修改密码</el-menu-item>
						<el-menu-item index="100-2"><i class="el-icon-switch-button"></i>退出</el-menu-item>

					</el-submenu>
				</el-menu>
				
			</el-header>
			<el-container style="height: 100%;">
				<!-- 侧边布局 -->
				
				<el-aside :width="menuwidth" :class="menuClass"  >
					
					<el-menu class="el-menu-vertical-demo"  :default-active="slideMenuActive" @select="slideSelect" style="height: 100%;overflow-y: auto;"   :collapse="isCollapse" 
					     
>

						<el-menu-item :index="index|numToString" v-for="(item,index) in slideMenus" :key="index" v-if="item.child.length===0">
							<i :class="item.icon"></i>
							<span slot="title">{{item.name}}
							<el-badge v-if="item.is_num &&  num_list[item.is_num]>0"  :value="num_list[item.is_num]" :max="99" class="item ml-2">
							</el-badge>
							</span>
						</el-menu-item>
						<el-submenu :index="index|numToString" v-else>
							<template slot="title">
								<i :class="item.icon"></i>
								<span>{{item.name}}
								<el-badge v-if="item.is_num &&  num_list[item.is_num]>0"  :value="num_list[item.is_num]" :max="99" class="item ml-2">
								</el-badge>
								</span>
							</template>
							<el-menu-item :index="index+'_'+index2" v-for="(v,index2) in item.child" :key="index2">
								<i :class="v.icon"></i>
								<span slot="title">{{v.name}}
								<el-badge v-if="v.is_num &&  num_list[v.is_num]>0"  :value="num_list[v.is_num]" :max="99" class="item ml-2">
								</el-badge>
								</span>
							</el-menu-item>
						</el-submenu>


					
					<div style="width: 100%;height: 100px;">

					</div>
					</el-menu>
				</el-aside>
				
			


				<!-- 主布局 -->
				<el-main class="bg-light" style="padding-bottom: 60px;position: relative;" v-loading="loading">

					<!-- 面包屑导航 -->
					<div class="border-bottom mb-3 bg-white" style="padding: 20px;margin: -20px;" v-if="bran.length > 0">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item v-for="(item,index) in bran" :key="index" :to="{ path: item.path }">{{item.title}}</el-breadcrumb-item>

						</el-breadcrumb>
					</div>
					<!-- 主内容 -->
					<router-view></router-view>

					<el-backtop target=".el-main" :bottom="100">
						<div style="{
					        height: 100%;
					        width: 100%;
					        background-color: #f2f5f6;
					        box-shadow: 0 0 6px rgba(0,0,0, .12);
					        text-align: center;
					        line-height: 40px;
					        color: #1989fa;
					      }">
							UP
						</div>
					</el-backtop>

				</el-main>
			</el-container>
		</el-container>

		<!-- 修改密码 -->
		<pass-mode :isphone="is_phone" :passModel="passModel" @hide="hidePassModel"></pass-mode>


		<!-- 修改个人资料 -->
		<info-edit :isphone="is_phone" :infoModel="infoModel" @hide="hideInfoModel"></info-edit>

		<!-- 公告明细 -->
		<noticeMode :isphone="is_phone" :noticeData="noticeData" :noticeModel="noticeModel" @hide="hideNoticeModel"></noticeMode>
		
		<!-- 快递查询 -->
		<expressInfo :isphone="is_phone" :expressData="expressData" :expressModel="expressModel" @hide="hideExpressModel"></expressInfo>

	</div>
</template>

<script>
	
	import common from '@/common/mixins/common.js';
	import passMode from '../components/common/pass-mode.vue';
	import infoEdit from '../components/common/info-edit.vue';
	import noticeMode from '../components/common/notice-mode.vue';
	import expressInfo from '../components/common/express-info.vue';
	import {
		mapState,
		mapMutations
	} from 'vuex';
	export default {

		mixins: [common],
		components: {
			passMode,
			infoEdit,
			noticeMode,
			expressInfo
		},
		provide() {
			return {
				layout: this
			}
		},
		data() {
			return {
				
				num_list:{
				},
				isCollapse:false,
				infoModel: false,
				noticeModel:false,
				expressModel:false,
				expressData:[],
				noticeData:[],
				
				user_mo: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
				//navBar: [],
				bran: [],
				passModel: false,
				loading: false,
				webSocket:null,
				scoketUrl: '',
				screenWidth: 0,
				scrollXWidth:200,
				is_phone:false,
				menuwidth:'auto',
				menuClass:'',
				index_p:{
					gutter:20,
					span1:9,
					span3:6,
					span2:12,
					gutter2:60,
					cardwidth:''
				}
			}
		},
		created() {
			//初始化菜单信息
			//this.navBar = this.$conf.navBar
			//this._isMobile()
			// 面包屑导航信息
			this.getRouterBran()
			// 初始化选中菜单
			this.__initNavBar()
			//this.initSocket()
			this.getPageNum()
		
		},
		destroyed() {
			// 页面销毁关闭连接
			this.webSocket.close()
		},
		mounted() {
			this.$nextTick(() =>{
				window.addEventListener('resize', this.handleResize);
				this.handleResize();
			});
		},
		watch: {
			'$route'(to, from) {
				 
				 let is_check = false
				this.navBar.active = '0'
				 for(let i = 0;i<this.navBar.list[0].submenu.length;i++){
					 if(is_check){
						 break
					 }
					if(this.navBar.list[0].submenu[i].child.length==0){
						if(this.navBar.list[0].submenu[i].pathname==to.name){
							
							this.slideMenuActive = i.toString()
							is_check = true
							break
						}
					}else{
						for(let j = 0;j<this.navBar.list[0].submenu[i].child.length;j++){
						
							if(this.navBar.list[0].submenu[i].child[j].pathname==to.name){
								
								this.slideMenuActive = i+'_'+j
								console.log(this.slideMenuActive)
								is_check = true
								break
							}
						}
					}
				 	
					
				 }
				 
				
				 localStorage.setItem('navActive', JSON.stringify({
				 	top: this.navBar.active,
				 	left: this.slideMenuActive
				 }))
				// console.log(this.navBar.active)
				// console.log(this.slideMenuActive)
				// 本地存储
				

				//console.log(this.slideMenuActive)
				this.getRouterBran()
			},
			isCollapse(newVal,oldVal){
				
				this.menuwidth = 'auto'
				if(newVal){
					if(this.is_phone){
						this.menuwidth = '0'
					}
				}
				if(this.isCollapse){
					this.scrollXWidth = 64
				}else{
					this.scrollXWidth = 200
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
				navBar: state => state.menu.navBar

			}),
			slideMenuActive: {
				get() {
					let item = this.navBar.list[this.navBar.active]
					return item ? item.subActive : '0'
				},
				set(val) {
					let item = this.navBar.list[this.navBar.active]
					if (item) {
						item.subActive = val
					}
					//console.log(this.navBar.active)
					//this.navBar.list[this.navBar.active].subActive = val
					//console.log(this.navBar.list[this.navBar.active].subActive )
				}
			},
			slideMenus() {
				let item = this.navBar.list[this.navBar.active]
				//console.log(item);
				return item ? item.submenu : []
			}
		},
		
		methods: {
			handleResize() {
				
				this.screenWidth = window.innerWidth;
				if(this.screenWidth<768){
					this.is_phone = true
				}else{
					this.is_phone = false
				}
				this.phoneHtml()
				//console.log(this.is_phone)
			},
			phoneHtml(){
				//console.log(this.is_phone)
				if(this.is_phone){
					this.isCollapse = true
					this.$refs.logowidth.style.display = 'none';
					this.$refs.memuicon.classList.remove('ml-4');
					this.menuClass = 'menu_float';
					if(this.isCollapse){
						this.menuwidth = '0'
					}else{
						this.menuwidth = 'auto'
					}
					this.index_p = {
						gutter:10,
						span1:24,
						span3:24,
						span2:24,
						gutter2:0,
						cardwidth:'110px'
					}
				}else{
					this.$refs.logowidth.style.display = 'block';
					this.$refs.memuicon.classList.add('ml-4');
					this.menuClass = '';
					this.menuwidth = 'auto'
					
					this.index_p = {
						gutter:20,
						span1:12,
						span3:6,
						span2:12,
						gutter2:60,
						cardwidth:'160px'
					}
				}
			},
			// 建立连接
			initSocket() {
				// 有参数的情况下：
				// 没有参数的情况:接口
				// let url1 = 'ws://localhost:9998'
				this.webSocket = new WebSocket(this.scoketUrl)
				this.webSocket.onopen = this.webSocketOnOpen
				this.webSocket.onclose = this.webSocketOnClose
				this.webSocket.onmessage = this.webSocketOnMessage
				this.webSocket.onerror = this.webSocketOnError

			},
			// 建立连接成功后的状态
			webSocketOnOpen() {
				console.log('websocket连接成功');
			},
			// 获取到后台消息的事件，操作数据的代码在onmessage中书写
			webSocketOnMessage(res) {
				console.log(res)
				// res就是后台实时传过来的数据
				if(res.data.indexOf("apiSendXuanMessage") >= 0 ) {
					let list = JSON.parse(res.data);
					 if(list.type=='apiSendXuanMessage'){
					 	let data = list.data
						if(data.type==1){
							this.getPageNum()
						}
					 }
				} 
				//给后台发送数据
				//this.webSocket.send("发送数据");
			},
			// 关闭连接
			webSocketOnClose() {
				this.webSocket.close()
				console.log('websocket连接已关闭');
			},
			//连接失败的事件
			webSocketOnError(res) {
				console.log('websocket连接失败');
				// 打印失败的数据
				console.log(res);
			},
			
			commonTo(name,data={}){
				
				
				let is_check = false
				this.navBar.active = '0'
				 for(let i = 0;i<this.navBar.list[0].submenu.length;i++){
					 if(is_check){
						 break
					 }
					if(this.navBar.list[0].submenu[i].child.length==0){
						if(this.navBar.list[0].submenu[i].pathname==name){
							
							this.slideMenuActive = i.toString()
							is_check = true
							break
						}
					}else{
						for(let j = 0;j<this.navBar.list[0].submenu[i].child.length;j++){
						
							if(this.navBar.list[0].submenu[i].child[j].pathname==name){
								
								this.slideMenuActive = i+'_'+j
								console.log(this.slideMenuActive)
								is_check = true
								break
							}
						}
					}
				 	
					
				 }
				this.toUrl(data)
				
			},
			
			__initNavBar() {
				let r = localStorage.getItem('navActive')
				if (r) {
					r = JSON.parse(r)
					//console.log(r);
					this.navBar.active = r.top
					this.slideMenuActive = r.left
					//console.log(r.left)
					//console.log(this.slideMenuActive);
					
					this.toUrl()
					//console.log(this.slideMenuActive)
				}
			},
			
			
			_isMobile() {
			 //        let flag =             navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
					
				// if(flag){
				// 	this.is_phone = false
				// }else{
				// 	this.is_phone = true
				// }
			 //    console.log(flag)
			},
			
	
			handleEdit(){
				this.isCollapse = !this.isCollapse
			},
			//页面未处理数量
			getPageNum() {
				this.axios.post('/admin/user/adminPageNum', {}, {
					token: true,
				}).then(res => {
				
					let all = res.data
					let list = all.data.list
					this.num_list = list
				}).catch(err => {
					// 失败
					
				})
			},
			// 获取面包屑导航信息
			getRouterBran() {
				let b = this.$route.matched.filter(v => v.name)
				let arr = []
				b.forEach((v, k) => {
					if (v.name === 'index' || v.name === 'layout') return
					arr.push({
						name: v.name,
						path: v.path,
						title: v.meta.title
					})
				})
				if (arr.length > 0) {
					arr.unshift({
						name: 'index',
						path: '/index',
						title: '后台首页'
					});
				}
				this.bran = arr
			},
			showNoticeModel(data){
				this.noticeData = data
				this.axios.post('/admin/data/setNoticeRead', {id:data.id}, {
					token: true,
				}).then(res => {
					let all = res.data	
					this.getPageNum()
				}).catch(err => {
					// 失败
				})
				
				
				
				this.noticeModel = true
			},
			
			
			
			hideNoticeModel() {
				this.noticeModel = false
			},
			
			showExpressModel(data){

				 this.expressData.e_number = data
				 this.expressData.activities = []
				 this.expressData.is_data = 0
				
				this.axios.post('/admin/data/checkExpressData', {e_number:data}, {
				 	token: true,
					loading: true
				 }).then(res => {
				 	let all = res.data
					if(all.code==1){
						
						if(all.data.list.list.length>0){
							this.expressData.activities = all.data.list.list
							this.expressData.is_data = 1
						}
						
					}
					 this.expressModel = true
				 	//this.getPageNum()
				 }).catch(err => {
				 	// 失败
					this.expressModel = true
				 })

				
			},
			hideExpressModel() {
				this.expressModel = false
			},
			hideInfoModel() {
				let user = JSON.parse(window.sessionStorage.getItem('user'))
				this.user.name = user.name
				this.user.head = user.head
				this.infoModel = false
			},
			hidePassModel() {
				this.passModel = false
			},
			handleSelect(key, keyPath) {
				if(key== '200'){
					return false
				}
				console.log('handleSelect')
				if (key === '100-1') {
					return this.infoModel = true
					//console.log('修改个人信息');
				}
				if (key === '100-3') {
					return this.passModel = true

				}
				if (key === '100-2') {
					//退出
					return this.logout();
				}
				// console.log(key, keyPath);
				this.navBar.active = key;
				// 跳转到当前激活
				this.slideMenuActive = '0'
				//console.log(this.slideMenuActive);
				if (this.slideMenus.length > 0) {
					this.$router.push({
						name: this.slideMenus[this.slideMenuActive].pathname
					})
				}
			},
			logout() {
				//请求接口
				this.axios.post('/admin/user/logout', {}, {
					token: true,
					loading: true
				}).then(res => {
					//成功后
					this.$message('退出成功')
					this.$store.commit('logout')
					//返回到登录页
					this.$router.push({
						name: 'login'
					})
				}).catch(err => {
					//失败
					this.$message('退出成功')
					this.$store.commit('logout')
					this.$router.push({
						name: 'login'
					})
				})
			},
			slideSelect(key, keyPath) {
				//console.log(key)
				//console.log(key, keyPath);
				//this.navBar.list[this.navBar.active].subActive = key
				this.slideMenuActive = key
				//console.log(this.slideMenuActive);
				
				if(this.is_phone){
					this.isCollapse = true

				}
				this.toUrl();
			},
			toUrl(data={}) {
				
				let keys = new Array(); //定义一数组
				keys = this.slideMenuActive.split("_");
				//console.log(keys)
				if (keys.length === 2) {
					
					this.$router.push({
						name: this.slideMenus[keys[0]].child[keys[1]].pathname
					})
				} else {
					//跳转到指定页面
					this.$router.push({
						name: this.slideMenus[this.slideMenuActive].pathname,
						params:data
					})
				}
			},

		}
	}
</script>

<style>
	
	.el-menu-vertical-demo:not(.el-menu--collapse) {
	    width: 200px;
	  }
	  
	  .avatar-uploader .el-upload {
	      border: 1px dashed #d9d9d9;
	      border-radius: 6px;
	      cursor: pointer;
	      position: relative;
	      overflow: hidden;
	    }
	    .avatar-uploader .el-upload:hover {
	      border-color: #409EFF;
	    }
	    .avatar-uploader-icon {
	      font-size: 28px;
	      color: #8c939d;
	      width: 178px;
	      height: 178px;
	      line-height: 178px;
	      text-align: center;
	    }
	    .avatar {
	      width: 178px;
	      height: 178px;
	      display: block;
	    }
		
		.el-menu-item2{
			padding: 0 15px;
		}
		
		.lay_msg_btn{
			background-color: #545c64;
			color: #fff;
			border: none;
			
		}
		
		
		.tis_btn {
			width: 30px;
			    height: 30px;
			    line-height: 30px;
			    padding: 0!important;
		}
		
		
		.scrollbar {
		  position: absolute;
		  top: 0;
		  left: 0;
		  right: 0;
		  height: 8px; /* 滚动条的高度 */
		  background-color: #e5e5e5;
		  z-index: 1000; /* 确保滚动条在最上层 */
		
		  
		}
		
		.scrollbar .thumb {
		  position: absolute;
		  height: 100%;
		  width: 50px; /* 初始宽度 */
		  background-color: #acacac;
		  border-radius: 10px;
		  cursor: pointer;
		}
		
</style>